const Cart = () => {

    const clickInvoice = document.getElementById('woocommerce-invoice__checkbox');
    const invoiceWrapper = document.getElementsByClassName('woocommerce-invoice__fields')[0];
    
    if(clickInvoice) {
        clickInvoice.addEventListener('change', function() {

            if(this.checked) {
                invoiceWrapper.classList.add('active');
            } else {
                invoiceWrapper.classList.remove('active');
            }

        })
    }

    // Znajdowanie elementu .wc-social-login.form-row-wide
    var socialLoginElement = document.querySelector('.wc-social-login.form-row-wide');
    
    if (socialLoginElement) {
        // Dodawanie klasy do rodzica elementu .wc-social-login.form-row-wide
        socialLoginElement.parentElement.classList.add('custom-loggin-wrapper');
        
        // Tworzenie nowego elementu HTML
        var newElement = document.createElement('a');
        newElement.href = '/moje-konto/';
        newElement.classList.add('wc-social-home-login');
        newElement.textContent = 'Zaloguj się';

        // Dodawanie nowego elementu na drugą pozycję wewnątrz elementu .wc-social-login.form-row-wide
        socialLoginElement.insertBefore(newElement, socialLoginElement.children[1]);
    }

}

export default Cart;